function removeElementsBasedOnScreenSize() {
  if ($(window).width() >= 988) {
    $('.power-review-mob').remove();
  } else {
    $('.power-review-desk').remove();
  }
}
  $(document).ready(function() {
    removeElementsBasedOnScreenSize();
  });
  $(window).resize(function() {
    removeElementsBasedOnScreenSize();
  });

$(document).ready(function() {  
    //Morphing border Animation
    var $menuItems = $('.cat-link-wrap ul li');
    var $borderSlide = $('.border-slide');
    // Initialize the border width and position on load
    setBorderWidth();
    // Update the border width and position on window resize
    $(window).resize(function() {
      setBorderWidth();
    });
    // Handle menu item hover events
    $menuItems.hover(
      function() {
        var width = $(this).outerWidth();
        var offsetLeft = $(this).position().left;
        $borderSlide.css({
          width: width + 'px',
          transform: 'translateX(' + offsetLeft + 'px)'
        });
      },
      function() {
        var $activeMenuItem = $('.cat-link-wrap ul li.active');
        if ($activeMenuItem.length > 0) {
          var width = $activeMenuItem.outerWidth();
          var offsetLeft = $activeMenuItem.position().left;
          $borderSlide.css({
            width: width + 'px',
            transform: 'translateX(' + offsetLeft + 'px)'
          });
        } else {
          $borderSlide.css({
            width: '0',
            transform: 'translateX(0)'
          });
        }
      }
    );
    // Handle menu item click events
    $menuItems.click(function(e) {
      e.preventDefault();
      $menuItems.removeClass('active');
      $(this).addClass('active');
      setBorderWidth();
    });
    // Set the border width and position based on the active menu item
    function setBorderWidth() {
      var $activeMenuItem = $('.cat-link-wrap ul li.active');
      if ($activeMenuItem.length > 0) {
        var width = $activeMenuItem.outerWidth();
        var offsetLeft = $activeMenuItem.position().left;
        $borderSlide.css({
          width: width + 'px',
          transform: 'translateX(' + offsetLeft + 'px)'
        });
      } else {
        $borderSlide.css({
          width: '0',
          transform: 'translateX(0)'
        });
      }
    }

  //Accordian Jquery
   $(".tab .tab-label").click(function(){
      $(this).closest(".tab").toggleClass("active");
      $(this).closest(".tab").siblings().removeClass("active");
      $(this).next().slideToggle();
      $(this).closest(".tab").siblings().find(".tab-content").slideUp();
   });

  $(".ScrollTo").click(function(event) {
    event.preventDefault();
    // Check if the href attribute is not blank and is not just "#"
    var href = $(this).attr("href");
    if (href !== "" && href !== "#") {
      var target = href; // Get the target element's ID

      // Check if the target element exists
      if ($(target).length) {
        // Animate scrolling to the target element
        $("html, body").animate({
          scrollTop: $(target).offset().top
        }, );
      }
    }
  });

  //Featured style and All Style Slider
  var $slider = $('.featured-style-list');
  var $slider2 = $('.all-style-listing');
  var sliderInitialized = false;
  function initSlider() {
    $slider.slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '87px',
      arrows: false,
      dots: false,
      initialSlide: 0,      
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 371,
          settings: {
            slidesToShow: 1,
            centerPadding: '50px',
          }
        }
      ]
    });

    $slider2.slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: '98px',
      arrows: false,
      dots: false,
      initialSlide: 0,      
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 371,
          settings: {
            slidesToShow: 1,
            centerPadding: '50px',
          }
        }
      ]
    });
    sliderInitialized = true;
  }
  
  function uninitSlider() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
      sliderInitialized = false;
    }
    if ($slider2.hasClass('slick-initialized')) {
      $slider2.slick('unslick');
      sliderInitialized = false;
    }
  }
  
  function handleSliderOnResize() {
    var windowWidth = $(window).width();
  
    if (windowWidth <= 989 && !sliderInitialized) {
      initSlider();
    } else if (windowWidth > 989 && sliderInitialized) {
      uninitSlider();
    }
  }
  
  // Initialize the slider on page load
  $(document).ready(function() {
    handleSliderOnResize();
  });
  
  // Reinitialize or uninitialize the slider on window resize
  $(window).on('resize', function() {
    handleSliderOnResize();
  });
 
});

// PDP media gallery 
 function showSlider() {
    $('#loading-image').hide();
    $('.main_images').css('visibility', 'visible');
  }
$(document).ready(function(){
 var initialSlideValue = $('.main_images').find('.img').length === 1 ? 0 : 1;
    
  $('.main_images').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
    arrows: false,
    initialSlide: initialSlideValue,
    fade: true,
    adaptiveHeight: true,
    asNavFor: '.thumb_images'
  });
   $('.main_images').on('init', function() {
    showSlider();
  });
  
 var initialThumbSlideValue = $('.thumb_images').find('.img').length === 1 ? 0 : 1;
  $('.thumb_images').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    swipeToSlide: true,
    infinite: true,
    initialSlide: initialThumbSlideValue,
    asNavFor: '.main_images',
    dots: false,
    arrows: true,
    centerMode: false,
    focusOnSelect: true,
    prevArrow: "<button type='button' class='slick-prev slick-arrows'><svg width='20' height='20' viewBox='0 0 20 20' fill='#007DB6' xmlns='http://www.w3.org/2000/svg'> <path d='M13.586 18.9706L15.0002 17.5563L7.92918 10.4853L15.0002 3.41421L13.586 2L5.10075 10.4853L13.586 18.9706Z'/> </svg></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrows'><svg width='20' height='20' viewBox='0 0 20 20' fill='#007DB6' xmlns='http://www.w3.org/2000/svg'> <path d='M6.41421 18.9706L5 17.5563L12.0711 10.4853L5 3.41421L6.41421 2L14.8995 10.4853L6.41421 18.9706Z'/> </svg></button>",
    responsive: [
      {
        breakpoint: 990,
        settings: {
          arrows: false,
          infinite: false,
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 5,
          infinite: false,
        }
      }
    ]
  });  
});

setTimeout(function() {
  showSlider();
}, 500);


// PDP media gallery zoom
function zoom(e){
  var zoomer = e.currentTarget;
  zoomer.style.backgroundSize = '150% 155%';
  e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
  e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX
  x = offsetX/zoomer.offsetWidth*100
  y = offsetY/zoomer.offsetHeight*100
  zoomer.style.backgroundPosition = x + '% ' + y + '%';
}


$(document).ready(function() {
  
//Limited Offer 
  var offerDate = $('#offer-date').text();
  var parts = offerDate.split('/');
  var day = parseInt(parts[0], 10);
  var month = parseInt(parts[1], 10) - 1;
  var year = parseInt(parts[2], 10);
  var offerDateTime = new Date(year, month, day);

  if (offerDateTime < new Date()) {
    $('#limited-offer').hide();
    // $('#on-sale-badge').hide();
  }


});

$(window).on('load', function() {
    $('.product-grid-slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      prevArrow:"<button type='button' class='slick-prev'><svg width='22' height='22' viewBox='0 0 22 22' fill='#007DB6' xmlns='http://www.w3.org/2000/svg'> <path d='M19.7498 10.0399H4.74984L10.7198 4.06986C10.7673 4.02474 10.8051 3.97045 10.8309 3.91028C10.8567 3.85011 10.87 3.78533 10.87 3.71986C10.87 3.65439 10.8567 3.5896 10.8309 3.52943C10.8051 3.46927 10.7673 3.41498 10.7198 3.36986L10.3698 3.00986C10.2743 2.9183 10.1471 2.86719 10.0148 2.86719C9.88253 2.86719 9.75535 2.9183 9.65984 3.00986L2.23984 10.4399C2.14828 10.5354 2.09717 10.6626 2.09717 10.7949C2.09717 10.9272 2.14828 11.0543 2.23984 11.1499L9.62984 18.9899C9.72535 19.0814 9.85253 19.1325 9.98484 19.1325C10.1171 19.1325 10.2443 19.0814 10.3398 18.9899L10.6898 18.6399C10.7814 18.5443 10.8325 18.4172 10.8325 18.2849C10.8325 18.1526 10.7814 18.0254 10.6898 17.9299L4.75984 11.4999L19.7498 11.4999C19.8161 11.4999 19.8797 11.4735 19.9266 11.4266C19.9735 11.3798 19.9998 11.3162 19.9998 11.2499V10.2899C19.9998 10.2236 19.9735 10.16 19.9266 10.1131C19.8797 10.0662 19.8161 10.0399 19.7498 10.0399Z'/> </svg></button>",
      nextArrow:"<button type='button' class='slick-next'><svg width='22' height='22' viewBox='0 0 22 22' fill='#007DB6' xmlns='http://www.w3.org/2000/svg'> <path d='M2.24992 11.9601H17.2499L11.2799 17.9301C11.2325 17.9753 11.1947 18.0296 11.1689 18.0897C11.1431 18.1499 11.1298 18.2147 11.1298 18.2801C11.1298 18.3456 11.1431 18.4104 11.1689 18.4706C11.1947 18.5307 11.2325 18.585 11.2799 18.6301L11.6299 18.9901C11.7254 19.0817 11.8526 19.1328 11.9849 19.1328C12.1172 19.1328 12.2444 19.0817 12.3399 18.9901L19.7599 11.5601C19.8515 11.4646 19.9026 11.3374 19.9026 11.2051C19.9026 11.0728 19.8515 10.9457 19.7599 10.8501L12.3699 3.01014C12.2744 2.91859 12.1472 2.86747 12.0149 2.86747C11.8826 2.86747 11.7554 2.91859 11.6599 3.01014L11.3099 3.36014C11.2184 3.45565 11.1672 3.58284 11.1672 3.71514C11.1672 3.84745 11.2184 3.97463 11.3099 4.07014L17.2399 10.5001L2.24992 10.5001C2.18361 10.5001 2.12003 10.5265 2.07314 10.5734C2.02626 10.6202 1.99992 10.6838 1.99992 10.7501V11.7101C1.99992 11.7764 2.02626 11.84 2.07314 11.8869C2.12003 11.9338 2.18361 11.9601 2.24992 11.9601Z' /> </svg></button>",
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding:'160px',
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding:'160px',
          }
        },
        {
          breakpoint: 371,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            centerMode: true,
            centerPadding:'70px',
          }
        },
      ]    
    });

  $('.testimonial-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    adaptiveHeight: true,
    prevArrow:"<button type='button' class='slick-prev'><svg width='22' height='22' viewBox='0 0 22 22' fill='#007DB6' xmlns='http://www.w3.org/2000/svg'> <path d='M19.7498 10.0399H4.74984L10.7198 4.06986C10.7673 4.02474 10.8051 3.97045 10.8309 3.91028C10.8567 3.85011 10.87 3.78533 10.87 3.71986C10.87 3.65439 10.8567 3.5896 10.8309 3.52943C10.8051 3.46927 10.7673 3.41498 10.7198 3.36986L10.3698 3.00986C10.2743 2.9183 10.1471 2.86719 10.0148 2.86719C9.88253 2.86719 9.75535 2.9183 9.65984 3.00986L2.23984 10.4399C2.14828 10.5354 2.09717 10.6626 2.09717 10.7949C2.09717 10.9272 2.14828 11.0543 2.23984 11.1499L9.62984 18.9899C9.72535 19.0814 9.85253 19.1325 9.98484 19.1325C10.1171 19.1325 10.2443 19.0814 10.3398 18.9899L10.6898 18.6399C10.7814 18.5443 10.8325 18.4172 10.8325 18.2849C10.8325 18.1526 10.7814 18.0254 10.6898 17.9299L4.75984 11.4999L19.7498 11.4999C19.8161 11.4999 19.8797 11.4735 19.9266 11.4266C19.9735 11.3798 19.9998 11.3162 19.9998 11.2499V10.2899C19.9998 10.2236 19.9735 10.16 19.9266 10.1131C19.8797 10.0662 19.8161 10.0399 19.7498 10.0399Z'/> </svg></button>",
    nextArrow:"<button type='button' class='slick-next'><svg width='22' height='22' viewBox='0 0 22 22' fill='#007DB6' xmlns='http://www.w3.org/2000/svg'> <path d='M2.24992 11.9601H17.2499L11.2799 17.9301C11.2325 17.9753 11.1947 18.0296 11.1689 18.0897C11.1431 18.1499 11.1298 18.2147 11.1298 18.2801C11.1298 18.3456 11.1431 18.4104 11.1689 18.4706C11.1947 18.5307 11.2325 18.585 11.2799 18.6301L11.6299 18.9901C11.7254 19.0817 11.8526 19.1328 11.9849 19.1328C12.1172 19.1328 12.2444 19.0817 12.3399 18.9901L19.7599 11.5601C19.8515 11.4646 19.9026 11.3374 19.9026 11.2051C19.9026 11.0728 19.8515 10.9457 19.7599 10.8501L12.3699 3.01014C12.2744 2.91859 12.1472 2.86747 12.0149 2.86747C11.8826 2.86747 11.7554 2.91859 11.6599 3.01014L11.3099 3.36014C11.2184 3.45565 11.1672 3.58284 11.1672 3.71514C11.1672 3.84745 11.2184 3.97463 11.3099 4.07014L17.2399 10.5001L2.24992 10.5001C2.18361 10.5001 2.12003 10.5265 2.07314 10.5734C2.02626 10.6202 1.99992 10.6838 1.99992 10.7501V11.7101C1.99992 11.7764 2.02626 11.84 2.07314 11.8869C2.12003 11.9338 2.18361 11.9601 2.24992 11.9601Z' /> </svg></button>", 
  });

});

 